import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import LzMCrud from '@lz-models/crud/Crud';
import { getFormattedAmount } from 'services/Utils';
import SalesInvoiceModel from './sales-invoice.model';
import SalesInvoiceFBRSubmissionComponent from './SalesInvoiceFBRSubmissionComponent';

const config = new LzMCrud({
    ident: 'sales-invoices',
    baseRoute: '/content/sales-invoices',
    className: 'lz-sales-invoice-entity',
    fields: {
        sales_tax_invoice_no: { size: 20, type: 'string', required: true },
        invoice_date: { type: 'string', required: true },
        invoice_no: { size: 20, type: 'string', required: true },
        // buyer_name: { size: 100, type: 'string', required: true },
        invoice_value: { type: 'number' },
        fbr_invoice_no: { size: 50, type: 'string' },
    },
    listingColumns: {
        sales_tax_invoice_no: { label: 'S.Tax. Inv. No.', sortable: true, alignment: 'left' },
        invoice_date: { label: 'Invoice Date', sortable: true, alignment: 'left' },
        invoice_no: { label: 'Invoice No.', sortable: true, alignment: 'left' },
        // buyer_name: { label: 'Buyer Name', sortable: true, alignment: 'left' },
        invoice_value: { label: 'Invoice Value', sortable: true, alignment: 'left', displayFunction: (val) => getFormattedAmount(val, false) },
        fbr_invoice_no: { label: 'FBR Invoiced', sortable: true, alignment: 'left', displayFunction: (val, rec, _, updateRecord) => <SalesInvoiceFBRSubmissionComponent fbrInvoiceNo={val} data={rec} onChange={(data: SalesInvoiceModel) => { if (typeof updateRecord !== 'undefined') { updateRecord(data, true); } }} /> },
    },
    showView: false,
    showStatus: false,
    listingActionIcons: {
        'delete': { title: 'Delete', icon: <DeleteIcon />, color: 'error', sortOrder: 5, hideOnCondition: (rec) => rec.is_fbr_registered },
        'edit': { route: '{baseRoute}/{recordId}/edit', getTitle: (rec) => rec.is_fbr_registered ? 'View' : 'Edit', getIcon: (rec) => rec.is_fbr_registered ? <VisibilityIcon /> : <EditIcon />, color: 'info', hideOnDeleted: true, sortOrder: 10 },
        'print': { title: 'Print', color: 'primary', icon: <PrintIcon />, route: '/#/content/sales-invoices/{recordId}/print', openNewWindow: true, sortOrder: 15, },
    },
});

export default config;
